module.exports = __webpack_public_path__ + "c_static/img/淘宝付款截图.36f61be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/淘宝付款截图.jpg
// module id = MfVs
// module chunks = 33